import { inject, NgModule } from '@angular/core';

import { BaseTranslatableModule } from 'app/core/internationalization/translatable-module';
import { TranslationLoaderHelper } from 'app/core/internationalization/translation-loader-helper';

import { A11yAlertDirective } from './directives/a11y-alert.directive';
import { A11yCarouselDirective } from './directives/a11y-carousel.directive';
import { A11yCarouselDotDirective } from './directives/a11y-carousel-dot.directive';
import { A11yClickableDirective } from './directives/a11y-clickable.directive';
import { A11yCurrentPageDirective } from './directives/a11y-current-page.directive';
import { A11yDescriptionSourceDirective } from './directives/a11y-description-source.directive';
import { A11yDialogDirective } from './directives/a11y-dialog.directive';
import { A11yDialogCloseRequestDirective } from './directives/a11y-dialog-close-request.directive';
import { A11yDisclosureDirective } from './directives/a11y-disclosure.directive';
import { A11yDisclosurePanelDirective } from './directives/a11y-disclosure-panel.directive';
import { A11yDisclosureTriggerDirective } from './directives/a11y-disclosure-trigger.directive';
import { A11yDropdownTriggerDirective } from './directives/a11y-dropdown-trigger.directive';
import { A11yFieldDirective } from './directives/a11y-field.directive';
import { A11yFocusWhenCurrentPageDirective } from './directives/a11y-focus-when-current-page.directive';
import { A11yGroupDirective } from './directives/a11y-group.directive';
import { A11yHiddenDirective } from './directives/a11y-hidden.directive';
import { A11yActionButtonDirective } from './directives/a11y-action-button.directive';
import { A11yImageDirective } from './directives/a11y-image.directive';
import { A11yLabelDirective } from './directives/a11y-label.directive';
import { A11yLabelSourceDirective } from './directives/a11y-label-source.directive';
import { A11yListDirective } from './directives/a11y-list.directive';
import { A11yMenuDirective } from './directives/a11y-menu.directive';
import { A11yMenuItemDirective } from './directives/a11y-menu-item.directive';
import { A11yOtpInputDirective } from './directives/a11y-otp-input.directive';
import { A11yPressedDirective } from './directives/a11y-pressed.directive';
import { A11yProgressbarDirective } from './directives/a11y-progress-bar.directive';
import { A11yRadioDirective } from './directives/a11y-radio.directive';
import { A11yRadioGroupDirective } from './directives/a11y-radio-group.directive';
import { A11yRegionDirective } from './directives/a11y-region.directive';
import { A11ySearchDirective } from './directives/a11y-search.directive';
import { A11yStepIndicatorDirective } from './directives/a11y-step-indicator.directive';
import { A11yStripeElementDirective } from './directives/a11y-stripe-element.directive';
import { A11ySwitchDirective } from './directives/a11y-switch.directive';
import { A11yTabDirective } from './directives/a11y-tab.directive';
import { A11yTableHeaderDirective } from './directives/a11y-table-header.directive';
import { A11yTabpanelDirective } from './directives/a11y-tabpanel.directive';
import { A11yTablistDirective } from './directives/a11y-tabs.directive';
import { A11yTimerDirective } from './directives/a11y-timer.directive';
import { A11yTooltipDirective } from './directives/a11y-tooltip.directive';

const ACCESSIBILITY_DIRECTIVES = [
  A11yAlertDirective,
  A11yCarouselDotDirective,
  A11yCarouselDirective,
  A11yClickableDirective,
  A11yCurrentPageDirective,
  A11yDialogDirective,
  A11yDialogCloseRequestDirective,
  A11yDescriptionSourceDirective,
  A11yDisclosureDirective,
  A11yDisclosurePanelDirective,
  A11yDisclosureTriggerDirective,
  A11yDropdownTriggerDirective,
  A11yFieldDirective,
  A11yFocusWhenCurrentPageDirective,
  A11yGroupDirective,
  A11yHiddenDirective,
  A11yActionButtonDirective,
  A11yImageDirective,
  A11yLabelDirective,
  A11yLabelSourceDirective,
  A11yListDirective,
  A11yMenuDirective,
  A11yMenuItemDirective,
  A11yOtpInputDirective,
  A11yPressedDirective,
  A11yProgressbarDirective,
  A11yRadioDirective,
  A11yRadioGroupDirective,
  A11yRegionDirective,
  A11ySearchDirective,
  A11yStepIndicatorDirective,
  A11yStripeElementDirective,
  A11ySwitchDirective,
  A11yTabDirective,
  A11yTableHeaderDirective,
  A11yTablistDirective,
  A11yTabpanelDirective,
  A11yTimerDirective,
  A11yTooltipDirective
];

@NgModule({
  imports: ACCESSIBILITY_DIRECTIVES,
  exports: ACCESSIBILITY_DIRECTIVES
})
export class AccessibilityModule extends BaseTranslatableModule {
  public constructor() {
    const translationLoaderHelper = inject(TranslationLoaderHelper);

    super(translationLoaderHelper, 'shared/accessibility');
  }
}
